var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWallet(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.5 8H19.5C13.136 8 9.95406 8 7.97703 10.0084C6 12.0168 6 15.2493 6 21.7143V26.2857C6 32.7507 6 35.9832 7.97703 37.9916C9.95406 40 13.136 40 19.5 40H28.5C34.864 40 38.0459 40 40.023 37.9916C42 35.9832 42 32.7507 42 26.2857V21.7143C42 15.2493 42 12.0168 40.023 10.0084C38.0459 8 34.864 8 28.5 8Z",
    stroke: "currentColor",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14 16H20",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M30 30.2222V25.7778C30 24.9397 30 24.5207 30.2603 24.2604C30.5207 24 30.9397 24 31.7778 24H40.2222C41.0603 24 41.4793 24 41.7397 24.2604C42 24.5207 42 24.9397 42 25.7778V30.2222C42 31.0603 42 31.4793 41.7397 31.7397C41.4793 32 41.0603 32 40.2222 32H31.7778C30.9397 32 30.5207 32 30.2603 31.7397C30 31.4793 30 31.0603 30 30.2222Z",
    stroke: "currentColor",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWallet);
export default __webpack_public_path__ + "static/media/wallet.f5c62352cd78f603a6b31a75c07ee30c.svg";
export { ForwardRef as ReactComponent };